import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { OrdersPaymentMethodSummary } from "@models/orders-payment-method-summary";
import { DashboardCardComponent } from "@shared/components/cards/dashboard-card/dashboard-card.component";
import {
  PieChartComponent,
  PieChartSegment,
} from "@shared/components/pie-chart/pie-chart.component";
import { PaymentMethodPipe } from "@shared/pipes/payment-method.pipe";
import { SkeletonModule } from "primeng/skeleton";
import { map } from "rxjs";
import { RevenueService } from "@services/revenue.service";

@Component({
  selector: "app-payment-methods-chart-page",
  imports: [
    CommonModule,
    MatIconModule,
    SkeletonModule,
    DashboardCardComponent,
    PieChartComponent,
  ],
  templateUrl: "./payment-methods-chart-page.component.html",
  styleUrl: "./payment-methods-chart-page.component.scss",
})
export class PaymentMethodsChartPageComponent {
  private readonly revenueService = inject(RevenueService);
  private readonly paymentMethodPipe = new PaymentMethodPipe();

  paymentMethodSegments$ = this.revenueService
    .getPaymentMethodsForOrganizer()
    .pipe(map((items) => this.toPaymentSegments(items)));

  private toPaymentSegments(
    items: OrdersPaymentMethodSummary[],
  ): PieChartSegment[] {
    return items.map((item) => ({
      label: this.paymentMethodPipe.transform(item.payment_method),
      value: item.sales_quantity,
      amount: item.total_amount,
    }));
  }
}
